export const State = {
  valid: 'valid',
  invalid: 'invalid',
  loading: 'loading',
  exists: 'exists',
  alert: 'alert',
  warning: 'warning',
  visible: 'visible',
  hidden: 'hidden',
  notFound: 'not-found',
  inactive: 'inactive',
  active: 'active',
  enter: 'enter',
  leave: 'leave'
}



// WEBPACK FOOTER //
// ./src/data/State.js